import { Controller } from "stimulus"

export default class extends Controller {
  //static targets = ["tilbakeButton"]
  
  connect() {
    //console.log("Connected", this.element)
  }

  exitGame() {
      location.href="./index.html"
  }
}